import React, { useState, useEffect } from 'react';
import {MultiSelect} from 'react-multi-select-component';
import Cookie from 'js-cookie';
import axios from 'axios';
import { Config } from '../config/config';

const Search: React.FC = (props) => {
  let stores = [];
  const config = JSON.parse(Config);

  if (props.name == 'cityDash') {
    stores = JSON.parse(localStorage?.getItem('storeData3')).sort((a, b) =>
      a.storeName > b.storeName ? 1 : -1
    );
  }
  let mean = '';
  let storesData = [];
  let stores1 = JSON.parse(localStorage.getItem('multiSearchCities'));
  let NotCheckedStoresData = [];
  if (localStorage.getItem('x') == null) {
    stores &&
      stores.map((val, index) => {
        if (val.currentStore == 1) {
          storesData.push({
            label: val.storeName,
            value: val.storeId,
          });
        }

        NotCheckedStoresData.push({
          label: val.storeName,
          value: val.storeId,
        });
      });
  } else {
    stores &&
      stores.map((val1, index) => {
        val1.activeFlag = 0;
        JSON.parse(stores1.data).map((val) => {
          if (val.label === val1.storeName) {
            val1.activeFlag = 1;
            storesData.push({
              label: val1.storeName,
              value: val1.storeId,
            });
          }
        });
        NotCheckedStoresData.push({
          label: val1.storeName,
          value: val1.storeId,
        });
      });
  }
  const [selected, setSelected] = useState(storesData);

  /* useEffect(() => {
    if (props.cityChanged) {
      setSelected([]);
    }
  }, [props.cityChanged]); */
  const selection = (e) => {
    setSelected(e);
    localStorage.setItem('x', 'x');

    props.name == 'cityDash'
      ? localStorage.setItem(
          'multiSearchCities',
          JSON.stringify({ type: props.name, data: JSON.stringify(e) })
        )
      : localStorage.setItem(
          'multiSearchCities',
          JSON.stringify({ type: props.name, data: JSON.stringify(e) })
        );
  };

  return (
    <>
      <MultiSelect
        className='multiSelectAll'
        options={NotCheckedStoresData}
        value={selected}
        onChange={selection}
        labelledBy={stores.storeName && stores.storeName}
        overrideStrings={{
          selectSomeItems: 'Search for stores',
          allItemsAreSelected: 'All stores are selected.',
          selectAll: 'Select All',
          search: 'Search',
        }}
      />
      {localStorage.getItem('x') == null
        ? props.name == 'cityDash'
          ? localStorage.setItem(
              'multiSearchCities',
              JSON.stringify({
                type: props.name,
                data: JSON.stringify(selected),
              })
            )
          : localStorage.setItem(
              'multiSearchCities',
              JSON.stringify({
                type: props.name,
                data: JSON.stringify(selected),
              })
            )
        : ''}
    </>
  );
};

export default Search;
